// constants
let GEOS = require('../constants/geos.json')

// build the code, name map
let country_map = {}
for (let geo of GEOS) {
  country_map[geo.value] = geo.label
}

// get country name by country code
const getCountryName = function (code) {
  return country_map[code]
}

module.exports = getCountryName
